import Skeleton from '../Skeleton';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const SkeletonAvatar: FunctionComponent<Props> = ({
    className = '',
    size = '3rem',
    testId = TEST_ID
}) => (
    <Skeleton className={className} height={size} testId={testId} variant='avatar' width={size} />
);

export default SkeletonAvatar;
